export default "__VITE_ASSET__$G1V6P9c__"